import { Action } from '@ngrx/store';
import { Easel } from '../../../_models/easel';
import { EaselType } from '../../../_models/easel_type';
import { EaselFamily } from '../../../_models/easel_family';
import { Product } from '../../../_models/product';

export enum EaselActitonTypes {

  ClearEasel = '[Easel] Clear',
  InicializeEasel = '[Easel] Inicialize',

  GetCurrentEasel = '[Easel] Get Current',
	SetCurrentEasel = '[Easel] Set Current',
	SetCurrentEaselId = '[Easel] Set Current Id',

	SetFilterFields = '[Easel] Set Filter Fields',

	LoadEasels = '[Easel] Get List',
	LoadEaselsSuccess = '[Easel] Load Success',
  LoadEaselsFail = '[Easel] Load Fail',

  UpdateEasel = '[Easel] Update',
  UpdateEaselSuccess = '[Easel] Update Success',
	UpdateEaselFail = '[Easel] Update Fail',

	CreateEasel = '[Easel] Create',
  CreateEaselSuccess = '[Easel] Create Success',
	CreateEaselFail = '[Easel] Create Fail',

	DeleteEasel = '[Easel] Delete',
  DeleteEaselSuccess = '[Easel] Delete Success',
	DeleteEaselFail = '[Easel] Delete Fail',

  LoadAllTypes = '[Easel] Get All types',
  LoadAllTypesSuccess = '[Easel] Get All types Success',
	LoadAllTypesFail = '[Easel] Get All types Fail',

	LoadFamilies = '[Easel] Get Families',
  LoadFamiliesSuccess = '[Easel] Get Families Success',
  LoadFamiliesFail = '[Easel] Get Families Fail',

  LoadFreights = '[Easel] Get All Freights',
  LoadFreightsSuccess = '[Easel] Get All Freights Success',
  LoadFreightsFail = '[Easel] Get All Freights Fail'
}

export class ClearEasel implements Action {
	readonly type = EaselActitonTypes.ClearEasel;
}

export class InicializeEasel implements Action {
	readonly type = EaselActitonTypes.InicializeEasel;
}

export class GetCurrentEasel implements Action {
	readonly type = EaselActitonTypes.GetCurrentEasel;
}

export class SetCurrentEasel implements Action {
	readonly type = EaselActitonTypes.SetCurrentEasel;

	constructor(public payload: Easel) {}
}

export class SetCurrentEaselId implements Action {
	readonly type = EaselActitonTypes.SetCurrentEaselId;

	constructor(public payload: bigint) {}
}

export class SetFilterFields implements Action {
	readonly type = EaselActitonTypes.SetFilterFields;

	constructor(public payload: any) {}
}

export class LoadEasels implements Action {
	readonly type = EaselActitonTypes.LoadEasels;

	constructor(public payload: any) {}
}

export class LoadEaselsSuccess implements Action {
	readonly type = EaselActitonTypes.LoadEaselsSuccess;

	constructor(public payload: Easel[]) {}
}

export class LoadEaselsFail implements Action {
	readonly type = EaselActitonTypes.LoadEaselsFail;

	constructor(public payload: string) {}
}

export class UpdateEasel implements Action {
	readonly type = EaselActitonTypes.UpdateEasel;

	constructor(public payload: Easel) {}
}

export class UpdateEaselSuccess implements Action {
	readonly type = EaselActitonTypes.UpdateEaselSuccess;

	constructor(public payload: Easel) {}
}

export class UpdateEaselFail implements Action {
	readonly type = EaselActitonTypes.UpdateEaselFail;

	constructor(public payload: string) {}
}

export class DeleteEasel implements Action {
	readonly type = EaselActitonTypes.DeleteEasel;

	constructor(public payload: Easel) {}
}

export class DeleteEaselSuccess implements Action {
	readonly type = EaselActitonTypes.DeleteEaselSuccess;

	constructor(public payload: bigint) {}
}

export class DeleteEaselFail implements Action {
	readonly type = EaselActitonTypes.DeleteEaselFail;

	constructor(public payload: string) {}
}

export class CreateEasel implements Action {
	readonly type = EaselActitonTypes.CreateEasel;

	constructor(public payload: Easel) {}
}

export class CreateEaselSuccess implements Action {
	readonly type = EaselActitonTypes.CreateEaselSuccess;

	constructor(public payload: Easel) {}
}

export class CreateEaselFail implements Action {
	readonly type = EaselActitonTypes.CreateEaselFail;

	constructor(public payload: string) {}
}

// Carga de los tipos //

export class LoadAllTypes implements Action {
  readonly type = EaselActitonTypes.LoadAllTypes;
}

export class LoadAllTypesSuccess implements Action {
  readonly type = EaselActitonTypes.LoadAllTypesSuccess;

  constructor(public payload: EaselType[]) {}
}

export class LoadAllTypesFail implements Action {
  readonly type = EaselActitonTypes.LoadAllTypesFail;

  constructor(public payload: string) {}
}

// Carga de las familias //

export class LoadFamilies implements Action {
  readonly type = EaselActitonTypes.LoadFamilies;
}

export class LoadFamiliesSuccess implements Action {
  readonly type = EaselActitonTypes.LoadFamiliesSuccess;

  constructor(public payload: EaselFamily[]) {}
}

export class LoadFamiliesFail implements Action {
  readonly type = EaselActitonTypes.LoadFamiliesFail;

  constructor(public payload: string) {}
}

// Load freights //

export class LoadFreights implements Action {
  readonly type = EaselActitonTypes.LoadFreights;
  constructor(public payload: number ) {}
}

export class LoadFreightsSuccess implements Action {
  readonly type = EaselActitonTypes.LoadFreightsSuccess;

  constructor(public payload: Product[]) {}
}

export class LoadFreightsFail implements Action {
  readonly type = EaselActitonTypes.LoadFreightsFail;

  constructor(public payload: string) {}
}

// Unión de acciones
export type EaselActions = ClearEasel
| InicializeEasel
| GetCurrentEasel
| SetCurrentEasel
| SetCurrentEaselId
| SetFilterFields
| LoadEasels
| LoadEaselsSuccess
| LoadEaselsFail
| UpdateEasel
| UpdateEaselSuccess
| UpdateEaselFail
| CreateEasel
| CreateEaselSuccess
| CreateEaselFail
| DeleteEasel
| DeleteEaselSuccess
| DeleteEaselFail
| LoadAllTypes
| LoadAllTypesSuccess
| LoadAllTypesFail
| LoadFamilies
| LoadFamiliesSuccess
| LoadFamiliesFail
| LoadFreights
| LoadFreightsSuccess
| LoadFreightsFail;
